/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown>, value: NonNullable<unknown> }} Progress_Point_LabelInputs */

const en_us2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

const pt_br2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

const es_419_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

const pt_pt2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

const fr_fr2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} : ${i?.value}`)
};

const de_de2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

const it_it2_progress_point_label = /** @type {(inputs: Progress_Point_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{when}: {value}" |
*
* @param {Progress_Point_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_point_label = /** @type {((inputs: Progress_Point_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Point_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_point_label(inputs)
	if (locale === "es-419") return es_419_progress_point_label(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_point_label(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_point_label(inputs)
	if (locale === "de-DE") return de_de2_progress_point_label(inputs)
	if (locale === "it-IT") return it_it2_progress_point_label(inputs)
	return en_us2_progress_point_label(inputs)
});
export { progress_point_label as "progress.point_label" }